import { CircularProgress } from "@mui/material";

interface Props {
  label?: string;
}

export default function Loading(props: Props) {
  const { label = "Carregando…" } = props;

  return (
    <div
      className="mt-[10%] flex flex-col items-center justify-center gap-3 text-primary"
      role="status"
      aria-live="polite"
    >
      <CircularProgress color="inherit" size={48} />
      <p className="text-sm font-semibold text-muted">{label}</p>
    </div>
  );
}
